import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Brand from "@/components/Brand";
import LegalFooter from "@/components/LegalFooter";
import { Button } from "@/components/ui/button";

export default function LegalPageLayout({ title, updated, children, testid }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background" data-testid={testid}>
      <header className="glass sticky top-0 z-30 border-b border-border">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-3.5">
          <button onClick={() => navigate("/")}>
            <Brand />
          </button>
          <Button variant="outline" size="sm" onClick={() => navigate(-1)} data-testid="legal-back-btn">
            <ArrowLeft className="mr-1.5 h-4 w-4" /> Back
          </Button>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-12">
        <p className="font-mono-label text-xs text-muted-foreground">Legal</p>
        <h1 className="mt-2 font-heading text-4xl font-bold tracking-tight text-primary">{title}</h1>
        {updated && <p className="mt-2 text-sm text-muted-foreground">Last updated: {updated}</p>}
        <div className="prose mt-8 max-w-none text-[15px] leading-relaxed text-foreground">{children}</div>
      </main>

      <LegalFooter />
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-heading text-xl font-semibold text-primary">{heading}</h2>
      <div className="mt-3 space-y-3 text-muted-foreground">{children}</div>
    </section>
  );
}
